export default __webpack_public_path__ + "static/media/folder-create.61d20ea6.svg";